import React from 'react';
import { MultiApp, useAppConfig } from '@/config/context';
import { getCapitalPlatform } from '@/infrastructure/product-info';
import { CapitalPlatform } from '@/infrastructure/utils/app';


export interface AppSlotProps {
  apps: MultiApp[];
  platforms?: CapitalPlatform[];
  excludePlatforms?: CapitalPlatform[];
  extra?: any;
  children: React.ReactNode; // 必须传入 children
}

export interface PlatformSlotProps {
  platforms?: CapitalPlatform[];
  excludePlatforms?: CapitalPlatform[];
}

// @ts-ignore
export const AppSlot: React.FC<AppSlotProps> = (props) => {
  const config = useAppConfig();
  const enable = props.apps?.includes(config.currentApp);

  const platform = getCapitalPlatform();
  const platformEnable = !props.platforms ? true : props.platforms?.includes(platform as CapitalPlatform);

  const excludePlatformsEnable = !props.excludePlatforms ? true
    : !props.excludePlatforms?.includes(platform as CapitalPlatform);
  if (props.extra === '111') {
    console.log('AppSlot', enable, platformEnable, excludePlatformsEnable, props.children);
  }
  return (enable && platformEnable && excludePlatformsEnable) ? props.children : null;
};

// @ts-ignore
export const PlatformSlot: React.FC<PlatformSlotProps> = (props) => {
  const platform = getCapitalPlatform();
  const platformEnable = !props.platforms ? true : props.platforms?.includes(platform as CapitalPlatform);

  const excludePlatformsEnable = !props.excludePlatforms ? true
    : !props.excludePlatforms?.includes(platform as CapitalPlatform);

  return (platformEnable && excludePlatformsEnable) ? props.children : null;
};

/**
 * 区分不同版本执行函数
 * @param func
 * @param apps
 * @returns
 */
export const runFuncWithApp = (func: () => any, apps: MultiApp[]) => {
  const currentApp = process.env.APP_VERSION as MultiApp;

  if (apps.includes(currentApp)) {
    return func?.();
  }

  return null;
};
